// UrlField.tsx
import React from 'react'
import { Typography, TextField } from '@mui/material'
import BaseDisplayItem, { BaseDisplayItemProps } from './BaseDisplayItem'

interface UrlFieldProps extends BaseDisplayItemProps<string> {
    kedo: {
        t: (key: string) => string
    }
    onKeyPress?: (
        id: string | number,
        e: React.KeyboardEvent<HTMLInputElement>
    ) => void
}

class UrlField extends BaseDisplayItem<string> {
    props!: UrlFieldProps

    getTarget(): '_blank' {
        return '_blank'
    }

    renderShow(): React.ReactNode {
        if (!this.state.value) {
            return (
                <Typography variant="body2" color="text.secondary">
                    {this.props.kedo.t('Unknown')}
                </Typography>
            )
        }

        return (
            <a
                href={this.state.value}
                target={this.getTarget()}
                rel="noopener noreferrer"
            >
                {this.state.value}
            </a>
        )
    }

    renderEdit(): React.ReactNode {
        return (
            <TextField
                size="small"
                fullWidth
                type="url"
                inputRef={this.innerRef}
                value={this.state.value}
                error={this.isInvalid()}
                helperText={this.isInvalid() ? this.props.errors : ''}
                onChange={(e) => this.updateValue(e.target.value)}
            />
        )
    }

    renderSearch(): React.ReactNode {
        return (
            <TextField
                size="small"
                fullWidth
                type="text"
                value={this.props.value ?? ''}
                onChange={(e) =>
                    this.props.changeValue?.(this.props.item.id, e.target.value)
                }
                onKeyPress={
                    this.props.onKeyPress
                        ? (e) => this.props.onKeyPress(this.props.item.id, e)
                        : undefined
                }
            />
        )
    }
}

export default UrlField
